export default __webpack_public_path__ + "static/media/Messages.467000d6.svg";